<div class="prototype-banner" role="status" data-testid="prototype-banner">
  <span>{{ bannerText }}</span>
</div>
